import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/';
import DadosInteressado from '../components/dados-interessado';


const mapStateToProps = (state, ownProps) => {
    return {...state.solicitacao.dadosInteressado, listNacionalidade: state.listNacionalidade};
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onConsultaCEP: (cep) => {
            dispatch(actions.consultaCEP(cep));
        },

        onEditarCPF: () => {
            dispatch(actions.onEditarCPF());
        },

        getListDeficiencia: () => {
            dispatch(actions.getListDeficiencia());
        },

        onChancheUF: (uf) => {
            dispatch(actions.changeCampoGenericoInteressado("uf", uf));
            dispatch(actions.getCidadesByUf(uf));
        },

        onContinuarCPF: (cpf) => {
            dispatch(actions.getDadosInteressadoCPF(cpf));
        },

        onContinuarCPF_conjuge: (cpf)=> {
            dispatch(actions.getDadosInteressadoConjugeCPF(cpf));
        },

        changeCampoGenericoInteressado: (campoState, valor) => {
            dispatch(actions.changeCampoGenericoInteressado(campoState, valor));
        },
        
        onEditarConjugeCPF: () =>{
            dispatch(actions.onEditarConjugeCPF());
        }
    };
};

const mergeProps = function (stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        onContinuarCPF: () => {
            dispatchProps.onContinuarCPF(stateProps.pesCPF);
        },
        onContinuarCPF_conjuge: () => {
            dispatchProps.onContinuarCPF_conjuge(stateProps.conjugePesCPF);
        }
    }
};


const DadosInteressadoContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(DadosInteressado);


export default DadosInteressadoContainer;


// WEBPACK FOOTER //
// ./src/containers/dados-interessado.js